/** Resolve a block index from a DOM node inside the note editor. */
export function blockIndexFromNode(node, root) {
  if (!node || !root) return null;
  const el = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
  const blockEl = el?.closest?.("[data-note-block-index]");
  if (!blockEl || !root.contains(blockEl)) return null;
  const index = Number(blockEl.dataset.noteBlockIndex);
  return Number.isNaN(index) ? null : index;
}

/** Non-collapsed selection spanning multiple blocks (when the browser allows it). */
export function getSelectedBlockRangeFromWindow(root) {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;

  const anchor = blockIndexFromNode(sel.anchorNode, root);
  const focus = blockIndexFromNode(sel.focusNode, root);
  if (anchor == null || focus == null || anchor === focus) return null;

  return {
    start: Math.min(anchor, focus),
    end: Math.max(anchor, focus),
  };
}

export function normalizeBlockRange(start, end) {
  const a = Math.max(0, Math.min(start, end));
  const b = Math.max(0, Math.max(start, end));
  return { start: a, end: b };
}

export function blockIndexInRange(index, range) {
  if (!range) return false;
  return index >= range.start && index <= range.end;
}

/** Block range for toolbar formatting: explicit multi-select, text selection, or focused block. */
export function getFormatBlockRange(root, blockSelection, fallbackIndex) {
  if (blockSelection) return blockSelection;

  const fromWindow = getSelectedBlockRangeFromWindow(root);
  if (fromWindow) return fromWindow;

  const active = document.activeElement;
  let idx = fallbackIndex ?? 0;
  if (active && root?.contains(active)) {
    const fromActive = blockIndexFromNode(active, root);
    if (fromActive != null) idx = fromActive;
  }

  return { start: idx, end: idx };
}
